import { useQuery } from 'react-query'

import { QueryKeys } from '../../../../../enums/queryKeys'
import { fetchFile } from '../../../../umbrella/routes/umbrellaProfile/query-api'

interface UseProfilePicResponse {
  isLoading: boolean
  url?: string
}

export const useProfilePic = (profilePicId?: string): UseProfilePicResponse => {
  const {
    data,
    isIdle,
    isLoading: isFileLoading,
  } = useQuery([QueryKeys.UserProfilePic, profilePicId], () => fetchFile(profilePicId as string), {
    enabled: !!profilePicId,
    keepPreviousData: true,
  })

  const isLoading = !!profilePicId && (isIdle || isFileLoading)

  return {
    isLoading,
    url: profilePicId ? data?.file.downloadUrl : undefined,
  }
}
